import { createContext, useContext, useState, ReactNode } from 'react';
import { Modal, Button } from 'react-bootstrap';

type ConfirmOptions = {
	title: string;
	message: string;
	onConfirm: () => void;
	onCancel?: () => void;
};

const ConfirmContext = createContext<(opts: ConfirmOptions) => void>(() => {});

export const useConfirm = () => useContext(ConfirmContext);

export function ConfirmProvider({ children }: { children: ReactNode }) {
	const [confirmState, setConfirmState] = useState<ConfirmOptions | null>(null);

	const triggerConfirm = (options: ConfirmOptions) => setConfirmState(options);

	const handleClose = () => {
		confirmState?.onCancel?.();
		setConfirmState(null);
	};

	const handleConfirm = () => {
		confirmState?.onConfirm();
		setConfirmState(null);
	};

	return (
		<ConfirmContext.Provider value={triggerConfirm}>
			{children}
			<Modal show={!!confirmState} onHide={handleClose} centered>
				<Modal.Header closeButton>
					<Modal.Title>{confirmState?.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>{confirmState?.message}</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Cancelar
					</Button>
					<Button variant="danger" onClick={handleConfirm}>
						Confirmar
					</Button>
				</Modal.Footer>
			</Modal>
		</ConfirmContext.Provider>
	);
}
